// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uploadFile {
  width: 100%;
  background-color: white;
  border: 1px solid #ced4da;
  border-radius: 5px;
  color: #212529;
  font-size: 14px;
  line-height: 21px;
  overflow: hidden;
  padding: 10px 10px 4px 10px;
  position: relative;
  resize: none;
}
.uploadFile [type=file] {
  cursor: pointer !important;
  display: block;
  font-size: 999px;
  filter: alpha(opacity=0);
  min-height: 100%;
  min-width: 100%;
  opacity: 0;
  position: absolute;
  right: 0px;
  text-align: right;
  top: 0px;
  z-index: 1;
}

.custom-file-button label {
  background-color: #07ab6a;
  color: white;
  cursor: pointer;
}

.custom-file-button:hover label {
  background-color: #06975d;
  color: white;
  cursor: pointer;
}

.form-control,
.form-select,
.form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/component/upload-document/upload-document.component.scss"],"names":[],"mappings":"AAuCA;EACI,WAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,2BAAA;EACA,kBAAA;EACA,YAAA;AAtCJ;AAwCI;EACI,0BAAA;EACA,cAAA;EACA,gBAAA;EACA,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,QAAA;EACA,UAAA;AAtCR;;AA0CA;EAEI,yBAAA;EACA,YAAA;EACA,eAAA;AAxCJ;;AA2CA;EACI,yBAAA;EACA,YAAA;EACA,eAAA;AAxCJ;;AA4CA;;;EAGI,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;AAzCJ","sourcesContent":["// .uploadFile {\r\n//   background-color: white;\r\n//   border: 1px solid #a0a0a0;\r\n//   color: #a0a0a0;\r\n//   width: 30%;\r\n//   font-size: 16px;\r\n//   line-height: 23px;\r\n//   overflow: hidden;\r\n//   padding: 10px 10px 4px 10px;\r\n//   position: relative;\r\n//   resize: none;\r\n\r\n//   label,\r\n//   i {\r\n//     color: #a0a0a0;\r\n//   }\r\n\r\n//   [type=\"file\"] {\r\n//     cursor: pointer !important;\r\n//     display: block;\r\n//     font-size: 999px;\r\n//     filter: alpha(opacity=0);\r\n//     min-height: 100%;\r\n//     min-width: 100%;\r\n//     opacity: 0;\r\n//     position: absolute;\r\n//     right: 0px;\r\n//     text-align: right;\r\n//     top: 0px;\r\n//     z-index: 1;\r\n//   }\r\n// }\r\n\r\n// .form-control {\r\n//   border-radius: 0 !important;\r\n// }\r\n\r\n\r\n//JAKES CODE\r\n.uploadFile {\r\n    width: 100%;\r\n    background-color: white;\r\n    border: 1px solid #ced4da;\r\n    border-radius: 5px;\r\n    color: #212529;\r\n    font-size: 14px;\r\n    line-height: 21px;\r\n    overflow: hidden;\r\n    padding: 10px 10px 4px 10px;\r\n    position: relative;\r\n    resize: none;\r\n\r\n    [type=\"file\"] {\r\n        cursor: pointer !important;\r\n        display: block;\r\n        font-size: 999px;\r\n        filter: alpha(opacity=0);\r\n        min-height: 100%;\r\n        min-width: 100%;\r\n        opacity: 0;\r\n        position: absolute;\r\n        right: 0px;\r\n        text-align: right;\r\n        top: 0px;\r\n        z-index: 1;\r\n    }\r\n}\r\n\r\n.custom-file-button label {\r\n\r\n    background-color: #07ab6a;\r\n    color: white;\r\n    cursor: pointer;\r\n}\r\n\r\n.custom-file-button:hover label {\r\n    background-color: #06975d;\r\n    color: white;\r\n    cursor: pointer;\r\n}\r\n\r\n\r\n.form-control,\r\n.form-select,\r\n.form-floating {\r\n    position: relative; // For focus state's z-index\r\n    flex: 1 1 auto;\r\n    width: 1%;\r\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
